export type RadioOptionValue = string | null;
export interface RadioOption { type: string, name: string};
